import { memo } from "react";

import { FormHeading } from "../../../components/FormHeading";
import { Grid } from "../../../components/Grid";

import { SummaryRow } from "./SummaryRow";
import style from "./SummarySection.module.scss";

type Data = Array<{ name: string; value: string | string[] | null }>;

type SummarySectionProps = {
  data: Data;
  title?: string;
};

const isDataEmpty = (data: Data) =>
  data.every(({ value }) => value === null || value === "");

export const SummarySection = memo<SummarySectionProps>(({ data, title }) => {
  if (data.length === 0 || isDataEmpty(data)) {
    return null;
  }

  return (
    <Grid container className={style.container}>
      {title && (
        <FormHeading
          component="h2"
          spacingBottom={2}
          title={title}
          variant="h3"
        />
      )}
      {data
        .filter(({ value }) =>
          Array.isArray(value) ? value.length > 0 : !!value
        )
        .map((row) => (
          <SummaryRow key={row.name} name={row.name} value={row.value} />
        ))}
    </Grid>
  );
});
